import React, {ChangeEventHandler, useCallback, useMemo, useState} from "react";
import {Button, Input, InputGroup} from "reactstrap";

export function PasswordField(
        {
            name,
            value,
            onChange
        }: {
            name: string,
            value: string,
            onChange: ChangeEventHandler<HTMLInputElement>
        }
) {
    const [isShown, setShown] = useState(false)

    const type = useMemo(() => isShown ? "text" : "password", [isShown]);
    const icon = useMemo(() => isShown ? "fa-eye-slash" : "fa-eye", [isShown]);

    const onButtonClick = useCallback((e: any) => {
        e.preventDefault();
        setShown(ref => !ref);
    }, [setShown])

    return <InputGroup className="p-0">
        <Input type={type} name={name} value={value} onChange={onChange}/>
        <Button className={`fa ${icon}`} color="primary" onClick={onButtonClick}/>
    </InputGroup>
}